<template lang="pug">
div.pt-2
  smart-table(
    :headers='headers'
    :adapter="adapter"
    :needToUpdateTable="needToUpdateTable"
  )
    template(#search--question_category_id="{ searchKeys, runSearch}")
      select-template-category(
        prepend-inner-icon="mdi-magnify"
        v-model="searchKeys.question_category_id"
        label=""
        placeholder="Категория"
        outlined
        dense
        hide-details
        @keyup.enter="runSearch"
        @input="runSearch"
      )
    template(#search--project_id="{ searchKeys, runSearch }")
      select-project(
        prepend-inner-icon="mdi-magnify"
        v-model="searchKeys.project_id"
        label=""
        placeholder="Проект"
        outlined
        dense
        hide-details
        @keyup.enter="runSearch"
        @input="runSearch"
      )
    template(#header)
      v-btn.mr-2(@click="dialogQuestionTemplate = !dialogQuestionTemplate" color="success")
        v-icon(left) mdi-plus
        | Добавить
    template(#value--project_id='{ item }')
      v-chip.mr-2.my-1(
        label
        color="secondary"
      )
        | {{ cachedProject(item.project_id).name }}
    template(#value--question_category_id="{ item }")
        template(v-if="item.question_category_id")
          | {{ cachedCategory(item.question_category_id).name }}
        template(v-else) -
    template(#value--action='{ item }')
      .d-flex
        v-btn.rounded.mr-1(color="primary" @click="editTemplate(item)" fab tile x-small)
          v-icon
            | mdi-pencil
        v-btn.rounded(color="error" @click='deleteCategory(item.id)' fab tile x-small)
          v-icon
            | mdi-trash-can
  create-question-template(
    :editData="editData"
    :value="dialogQuestionTemplate"
    @close="closeDialogCreateTemplate()"
  )
  confirm-form-dialog(
    v-model="dialogDelete"
    message="Действительно удалить шаблон?"
    @accept="acceptDeleteTemplate"
  )
</template>
<script>
import CreateQuestionTemplate from '@/components/dialogs/CreateQuestionTemplate.vue';
import AppEditor from '@/components/AppEditor.vue';
import SmartTable from '@/components/SmartTable/index.vue';
import { CRUDAnswerTemplates } from '@/services/API/_crud';
import SelectProject from '@/components/inputs/SelectProject.vue';
import SelectTemplateCategory from '@/components/inputs/SelectTemplateCategory.vue';
import rules from '@/lib/rules';
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import { CACHE_KEYS } from '@/store/modules/cache';
import SelectProjectRole from '@/components/inputs/SelectProjectRole.vue';

const DEFAULT_FORM = {
  project_id: null,
  question_category_id: null,
  user_role_id: null,
  text: '',
  name: '',
};

export default {
  components: {
    AppEditor,
    CreateQuestionTemplate,
    SmartTable,
    SelectProject,
    SelectTemplateCategory,
    ConfirmFormDialog,
    SelectProjectRole,
  },
  props: {
    question: { type: Object, default: null },
  },
  data: () => ({
    key: 1,
    dialog: false,
    dialogQuestionTemplate: false,
    editData: [],

    deleteCategoryId: null,
    dialogDelete: false,
    valid:false,
    headers: [
      {
        text: 'Название',
        align: 'name',
        value: 'name',
        searchable: true,
      },
      { text: 'Категория', value: 'question_category_id', searchable:true },
      { text: 'Проект', value: 'project_id', searchable:true },
      { text: 'Действия', value: 'action', sortable: false },
    ],
    updateTable:null,
    needToUpdateTable: false,
    form: { ...DEFAULT_FORM },
    categories: [],
    rules,
  }),

  computed: {
    ...mapGetters({
      'cachedCategory':'cache/cachedCategory',
      'cachedProject':'cache/cachedProject',
    }),
    formTitle() {
      return this.form.id ?  'Изменение шаблона' : 'Создание шаблона';
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
      this.$nextTick(() => { this.key += 1; });
    },
  },

  methods: {
    ...mapActions({
      'loadToCache': 'cache/loadToCache',
    }),
    editTemplate(item) {
      this.editData = item;
      this.dialogQuestionTemplate = true;
    },
    async adapter({ _update, ...options }) {
      this.needToUpdateTable = false;
      this.updateTable = _update;

      const params =  {
        'sort': '-id',
        'expand': 'project_id',
        ...options,
      };

      const response = await CRUDAnswerTemplates.getAll({ ...params  });

      const question_category_ids = response.data.data.map(({ question_category_id }) => question_category_id);
      await this.loadToCache({ key: CACHE_KEYS.question_categories, ids: question_category_ids });

      const projects_ids = response.data.data.map(({ project_id }) => project_id);
      await this.loadToCache({ key: CACHE_KEYS.projects, ids:projects_ids });

      return new Promise((resolve) => resolve(response));
    },

    async createTemplate() {
      if (!this.form.question_category_id) delete this.form.question_category_id;
      if (this.form.id) {
        const response = await CRUDAnswerTemplates.update(this.form.id, this.form);
        this.updateTable((items) => {
          const index = items.findIndex((item) => item.id === this.form.id);
          items[index] = response.data.data;
          return items;
        });
      } else {
        await CRUDAnswerTemplates.create(this.form);
        this.needToUpdateTable = true;
      }
      this.close();
    },

    editItem(item) {
      this.form = { ...item };
      this.dialog = true;
    },
    closeDialogCreateTemplate() {
      this.dialogQuestionTemplate = false;
      this.form = { ...DEFAULT_FORM };
      this.editData = [];
      this.needToUpdateTable = true;
    },
    deleteCategory(id) {
      this.deleteCategoryId = id;
      this.dialogDelete = true;
    },

    async acceptDeleteTemplate() {
      this.dialogDelete = false;
      await CRUDAnswerTemplates.delete(this.deleteCategoryId);
      this.needToUpdateTable = true;
    },

    close() {
      this.dialog = false;
      this.form = { ...DEFAULT_FORM };
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.form);
      } else {
        this.desserts.push(this.form);
      }
      this.close();
    },
  },
};
</script>

<style>

</style>
